import { createSlice, createAction } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  apiError: false,
  validTradeInNewResponse: '',
  validateTradeInValues: '',
  tradeInValueResp: '',
  updateCartTradeInResp: '',
  removeTradeInResp: '',
  tradeInSearchDevices: [],
  tradeInNewCompleted: false
};

const TradeInSlice = createSlice({
  name: 'TradeIn',
  initialState,
  reducers: {
    resetTradeInState: (state, action) => {
      return initialState;
    },
    setPageLoading: (state, action) => {
      state['loading'] = action.payload
    },
    setTradeInNewPageLoading: (state, action) => {
      state['loading'] = action.payload
    },
    setAPIError: (state, action) => {
      state['apiError'] = action.payload
    },
    setValidateTradeInNewDeviceIdResp: (state, action) => {
      state['validTradeInNewResponse'] = action.payload
    },
    setTradeInSearchDevices: (state, action) => {
      state['tradeInSearchDevices'] = action.payload
    },
    setValidateTradeInValues: (state, action) => {
      state['validateTradeInValues'] = action.payload
    },
    setTradeInComplete: (state, action) => {
      state['tradeInNewCompleted'] = action.payload
    },
    setTradeInNewDeviceInfo: (state, action) => {
      state['tradeInNewDeviceInfo'] = action.payload
    },
    setTradeInValueResp: (state, action) => {
      state['tradeInValueResp'] = action.payload;
    },
    setUpdateCartTradeInResp: (state, action) => {
      state['updateCartTradeInResp'] = action.payload;
    },
    setRemoveTradeInResp: (state, action) => {
      state['removeTradeInResp'] = action.payload;
    }
  },
});

export const reducer = TradeInSlice.reducer;
export const getSearchTradeInDevices = createAction('TradeInSlice/getSearchTradeInDevices');
export const validateTradeInValues = createAction('TradeInSlice/validateTradeInValues');
export const validateTradeInDevice = createAction('TradeInSlice/validateTradeInDevice');
export const getTradeInValue = createAction('TradeInSlice/getTradeInValue');
export const updateCartTradeIn = createAction('TradeInSlice/updateCartTradeIn');
export const removeTradeIn = createAction('TradeInSlice/removeTradeIn');
export const {
  setAPIError, setPageLoading, setValidateTradeInNewDeviceIdResp, setTradeInNewPageLoading, 
  setTradeInSearchDevices,setTradeInComplete, setTradeInNewDeviceInfo, setValidateTradeInValues,
  setTradeInValueResp, setUpdateCartTradeInResp, resetTradeInState, setRemoveTradeInResp,
} = TradeInSlice.actions;
